import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useBoardItem } from "../../hooks/useBoardItem";
import { SiteContext } from "../../context/SiteProvider";
import { PopupContext } from "../../context/PopupProvider";
import MyButton from "../../components/MyButton";

const DeleteBoardItemDialog = ({
  boardCode,
  itemNo,
  onRedirect = () => {},
}) => {
  const { t } = useTranslation();
  const { deleteBoardItemMutation } = useBoardItem();
  const queryClient = useQueryClient();
  const { setLoadingScreen } = useContext(SiteContext);

  const { closePopup } = useContext(PopupContext);

  const onDelete = async () => {
    setLoadingScreen(true);
    deleteBoardItemMutation.mutate(
      { boardCode, itemNo },
      {
        onSuccess: () => {
          alert(t("common.messages.boardItem.deleteSuccess"));
          queryClient.invalidateQueries({
            queryKey: ["/board-item?boardCode={boardCode}"],
          });
          closePopup();
          onRedirect();
        },
        onError: () => {
          alert(t("common.messages.boardItem.error"));
        },
        onSettled: () => {
          setLoadingScreen(false);
        },
      }
    );
  };

  return (
    <div className="md:p-12 p-8 rounded-2xl bg-white">
      <p className="md:text-2xl text-xl font-medium text-center mb-1">
        {t("common.messages.boardItem.deleteTitle")}
      </p>
      <p className="md:text-xl text-gray-dark text-center mb-6">
        {t("common.messages.boardItem.deleteConfirm")}
      </p>
      <div className="flex justify-center items-center gap-4">
        <MyButton onClick={closePopup}>{t("common.buttons.cancel")}</MyButton>
        <MyButton variant="contained" color="#e74c3c" onClick={onDelete}>
          {t("common.buttons.delete")}
        </MyButton>
      </div>
    </div>
  );
};

export default DeleteBoardItemDialog;
